import { onlyNumberAndCommonLetter } from "@/utils/regex"

export const formatToOnlyNumberAndCommonLetter = (value: string) => {
	const formattedValue = value.replace(onlyNumberAndCommonLetter, "")

	return formattedValue
}
